const errmsg = state => {
    return (state && state.errmsg) || ''
}
const loading = state => {
    return state.loading || 'loading'
}
const userInfo = state => {
    return state.userInfo || {}
}
const loadingSL = state => {
    return state.loadingSL || 'loadingSL'
}
const serverList = state => {
    return state.serverList || {}
}
const loadingRL = state => {
    return state.loadingRL || 'loadingRL'
}
const roleList = state => {
    return state.roleList || {}
}
const loadingAL = state => {
    return state.loadingAL || 'loadingAL'
}
const switchInfo = state => {
    return state.switchInfo || {}
}
const switching = state => {
    return state.switching || 'switching'
}
const areaList = state => {
    return state.areaList || {}
}
const uid = state => {
    return state.uid || ''
}
const deviceId = state => {
    return state.deviceId || ''
}
const token = state => {
    return state.token || ''
}
const appid = state => {
    return state.appid || ''
}
const uname = state => {
    return state.uname || ''
}
const cpUid = state => {
    return state.cpUid || ''
}
const phoneModel = state => {
    return state.phoneModel || ''
}
const clientPlat = state => {
    return state.clientPlat || ''
}
const channelId = state => {
    return state.channelId || ''
}
const roleName = state => {
    return state.roleName || ''
}
const serverName = state => {
    return state.serverName || ''
}
const areaId = state => {
    return state.areaId || ''
}
const serverId = state => {
    return state.serverId || ''
}
const roleId = state => {
    return state.roleId || ''
}
const lang = state => {
    return state.lang || 'en-US'
}
const sdkVersion = state => {
    return state.sdkVersion || ''
}
const apkVersion = state => {
    return state.apkVersion || ''
}
const loginTypes = state => {
    return state.loginTypes || ''
}
const isNewUploadLog = state => {
    return state.isNewUploadLog || ''
}
const uniqueId = state => {
    return state.uniqueId || ''
}
const showPage = state => {
    return state.showPage
}


export default {
    errmsg,
    loading,
    loginTypes,
    apkVersion,
    sdkVersion,
    userInfo,
    uid,
    deviceId,
    token,
    appid,
    cpUid,
    lang,
    uname,
    roleName,
    serverName,
    areaId,
    serverId,
    roleId,
    serverList,
    loadingSL,
    roleList,
    loadingRL,
    areaList,
    loadingAL,
    phoneModel,
    switchInfo,
    switching,
    clientPlat,
    channelId,
    isNewUploadLog,
    uniqueId,
    showPage
}